exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\niframe[data-v-a3b9f9e0] {\n    width: 100%;\n    height: 300px;\n    border: 0;\n    overflow: hidden;\n}\n@media (max-width: 1361px) {\niframe[data-v-a3b9f9e0] {\n        height: 450px;\n}\n}\n", ""]);

